import { ClubLogo } from './ClubLogo';

export default ClubLogo;
